// Keyed by platformAgentName: `amigo` on FoodAmigos, `assistant` on a partner's dashboard.
export default {
  label: {
    amigo: 'Ask Amigo',
    assistant: 'Assistant',
  },
  // The button's name while it shows a count of answers the person hasn't seen (the count itself is hidden from
  // screen readers).
  label_unread: {
    amigo_one: 'Ask Amigo, {{count}} new',
    amigo_other: 'Ask Amigo, {{count}} new',
    assistant_one: 'Assistant, {{count}} new',
    assistant_other: 'Assistant, {{count}} new',
  },
  unavailable_label: {
    amigo: 'Amigo unavailable',
    assistant: 'Assistant unavailable',
  },
  unavailable_text: {
    amigo: "Amigo isn't available right now.",
    assistant: "The assistant isn't available right now.",
  },
};
